import { Icon } from '@chakra-ui/react'

export const TabelleIcon = props => (
  <Icon viewBox='0 0 12 11' {...props}>
    <svg width='12' height='11' viewBox='0 0 12 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 0.358492L3.62264 0.358491L3.62264 1.9434L12 1.9434L12 0.358492ZM2.26415 0.358491L9.3031e-07 0.358491L7.91753e-07 1.9434L2.26415 1.9434L2.26415 0.358491ZM12 4.88679L3.62264 4.88679L3.62264 6.4717L12 6.4717L12 4.88679ZM2.26415 4.88679L5.34434e-07 4.88679L3.95877e-07 6.4717L2.26415 6.4717L2.26415 4.88679ZM12 9.41509L3.62264 9.41509L3.62264 11L12 11L12 9.41509ZM2.26415 11L2.26415 9.41509L1.38557e-07 9.41509L0 11L2.26415 11Z'
        fill='currentColor'
      />
    </svg>
  </Icon>
)
